function animateInputs() {
    const formInput = document.querySelectorAll('[data-input]');

	if (formInput.length > 0) {
		formInput.forEach((item) => {
			if (item.value !== '') {
				item.closest('[data-field]').classList.add('_focus');
			}
			item.addEventListener('focus', function () {
				if (this.value === '') {
					this.closest('[data-field]').classList.add('_focus');
				}
			});
			item.addEventListener('blur', function () {
				if (this.value === '') {
					this.closest('[data-field]').classList.remove('_focus');
				}
			});
		});
	}
}

function offset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

function animOnScroll() {  
    const animItems = document.querySelectorAll('._anim-items');  
    for (let index = 0; index < animItems.length; index++) {
        const animItem = animItems[index];
        const animItemHeight = animItem.offsetHeight;
        const animItemOffset = offset(animItem).top;
        const animStart = 4;

        let animItemPoint = window.innerHeight - animItemHeight / animStart;
        if (animItemHeight > window.innerHeight) {
            animItemPoint = window.innerHeight - window.innerHeight / animStart;
        }

        if ((window.pageYOffset > animItemOffset - animItemPoint) && window.pageYOffset < (animItemOffset + animItemHeight)) {
            animItem.classList.add('_active');
        } else if (!animItem.classList.contains('_anim-no-hide')) {
            animItem.classList.remove('_active');
        }
    }
}
export const AnimateFront = () => {
    const animItems = document.querySelectorAll('._anim-items');
    console.log('lets try to animate it', animItems);
    animateInputs();
    if (animItems.length > 0) {
        window.addEventListener('scroll', animOnScroll);
        setTimeout(() => {
            animOnScroll();
        }, 300);
    }
};
